import { render, staticRenderFns } from "./_Sub_categoria_sup.vue?vue&type=template&id=e2807fb4&scoped=true&"
import script from "./_Sub_categoria_sup.vue?vue&type=script&lang=js&"
export * from "./_Sub_categoria_sup.vue?vue&type=script&lang=js&"
import style0 from "./_Sub_categoria_sup.vue?vue&type=style&index=0&id=e2807fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2807fb4",
  null
  
)

export default component.exports